export enum UserDataType {
  SourceFile = "SourceFile",
  DeliveryFile = "DeliveryFile",
  WorkFile = "WorkFile",
}
